import {Init} from '@/core/Init'
import {APP_EVT} from '@/core/config/constants'
import {DesignData} from '@/core/main/Interface'

import * as svgjs from '@svgdotjs/svg.js';

class Reporting {

    static msg = '';
    static _logger: any[];

    constructor() {

        // catch the Window error event
        window.onerror = function (message, url, line, col, error) {

            console.log('window', error);
            //Init.reporting.report(error);

        };

        Reporting._logger = [];

        // $('#design-wrapper').on('mouseup', function (e) {
        //
        //     // Reporting._logger.push(e.originalEvent);
        //     // Reporting._logger = Reporting._logger.slice(0, 15);
        //     // console.log(Reporting._logger);
        //
        // });

    }

    // history: JSON.stringify(Reporting._logger)

    report(e: any): void {

        //console.log(e.stack);
        Init.emitter.emit(APP_EVT.FLASH_ERROR, e);

        let items: any = {};
        let inc = 0;

        for (let [itemId, item] of Init.set_design.items) {

            try {
                items[inc++] = item.getSaveData2d();
            } catch (e) {
                continue;
            }
        }

        let design_data: DesignData = {
            setScale: Init.design_scale,
            setX: 400,
            setY: 400,
            notes: Init.design_notes.getNotes(),
            meta: Init.line.getDesignMeta(),
            items: items
        };

        let metadata: any = {
            builder_version: Init.builder_version,
            series_id: Init.series_id,
            app_role: Init.app_role,
            line_name: Init.line_name,
            active_item: Init.active_item,
            design_name: Init.design_name,
            option_mode_active: Init.option_mode_active,
            options_active: Init.options_active,
            document_referrer: document.referrer,
            document_uri: window.location.pathname + window.location.search

        };

        let design_str: string = JSON.stringify(design_data);
        let metadata_str: string = JSON.stringify(metadata);

        let data: any = {
            name: e.name,
            design_data: design_str,
            message: e.message,
            metadata: metadata_str,
            stack: e.stack,
            history: ''

        };

        $.ajax({
            type: 'POST',
            url: '/reporting/submitReport',
            dataType: 'json',
            data: data
        })
            .done(function (data) {

                console.log(e);
                // Init.emitter.emit(APP_EVT.FLASH_ERROR, e);

            })
            .fail(function (data) {
                //Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            });

    }

}

export {Reporting};

